import type { IFreeSlotItem } from '../../../../../types/schedule';
import type { SchedulePlacementController } from './schedulePlacementState';

export function schedulePlacementPropsAreEqual(
  prev: SchedulePlacementController,
  next: SchedulePlacementController
): boolean {
  return (
    prev.keyboardModifierHeld === next.keyboardModifierHeld &&
    prev.shiftModifierHeld === next.shiftModifierHeld &&
    prev.clickPlacement === next.clickPlacement &&
    prev.dragPlacement === next.dragPlacement &&
    prev.pendingPlaceMatchId === next.pendingPlaceMatchId &&
    prev.pendingPlacementSource === next.pendingPlacementSource &&
    prev.placementBannerDismissed === next.placementBannerDismissed &&
    prev.pendingPlaceMatch === next.pendingPlaceMatch &&
    prev.activePlacementMatch === next.activePlacementMatch &&
    prev.focusedPlacementSlot === next.focusedPlacementSlot &&
    prev.focusedSwapTargetMatchId === next.focusedSwapTargetMatchId &&
    prev.swapModifierHeld === next.swapModifierHeld &&
    prev.placementSessionReady === next.placementSessionReady &&
    prev.placementSessionIndex === next.placementSessionIndex &&
    prev.handlePlacementBannerPointerDownCapture ===
      next.handlePlacementBannerPointerDownCapture &&
    prev.handlePlaceAtFreeSlot === next.handlePlaceAtFreeSlot &&
    prev.handleSwapPendingWithScheduled === next.handleSwapPendingWithScheduled &&
    prev.handleSelectUnscheduledForPlacement === next.handleSelectUnscheduledForPlacement &&
    prev.handleSelectGridMatchForPlacement === next.handleSelectGridMatchForPlacement &&
    prev.resolveMatchFromDnDData === next.resolveMatchFromDnDData &&
    prev.setClickPlacement === next.setClickPlacement &&
    prev.setDragPlacement === next.setDragPlacement
  );
}

export function focusedPlacementSlotForGrid(
  placement: SchedulePlacementController
): IFreeSlotItem | null {
  return placement.clickPlacement != null &&
    placement.dragPlacement == null &&
    placement.placementSessionReady &&
    !(placement.swapModifierHeld && placement.focusedSwapTargetMatchId)
    ? placement.focusedPlacementSlot
    : null;
}
